import styled from 'styled-components';

export const IconsWrap = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__IconsWrap", componentId: "sc-1tkywcm-0" })(["display:flex;margin-top:", ";"],

({ theme }) => theme.spacers.M);


export const Circle = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__Circle", componentId: "sc-1tkywcm-1" })(["width:48px;height:48px;grid-area:icon;place-self:center left;position:relative;display:flex;justify-content:center;align-items:center;border-radius:50%;overflow:hidden;"]);












export const CircleBackground = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__CircleBackground", componentId: "sc-1tkywcm-2" })(["background-color:", ";opacity:0.1;position:absolute;width:100%;height:100%;"],
({ theme }) => theme.colors.Color2_75);






export const IconContainer = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__IconContainer", componentId: "sc-1tkywcm-3" })(["cursor:pointer;&:first-child{margin-right:", ";}"],


({ theme }) => theme.spacers.M);



export const Title = /*#__PURE__*/styled.h2.withConfig({ displayName: "styles__Title", componentId: "sc-1tkywcm-4" })(["", ";color:", ";padding-bottom:", ";padding-right:", ";"],
({ theme }) => theme.typography.SmallHeadline,
({ theme }) => theme.colors.Foreground,
({ theme }) => theme.spacers.M,
({ theme }) => theme.spacers.XL);


export const Paragraph = /*#__PURE__*/styled.p.withConfig({ displayName: "styles__Paragraph", componentId: "sc-1tkywcm-5" })(["", ";color:", ";"],
({ theme }) => theme.typography.Paragraph,
({ theme }) => theme.colors['Level 5']);


export const StyledTextArea = /*#__PURE__*/styled.textarea.attrs({ rows: 1, maxLength: 1000 }).withConfig({ displayName: "styles__StyledTextArea", componentId: "sc-1tkywcm-6" })(["width:100%;height:92px;border:1px solid ", ";box-sizing:border-box;border-radius:4px;resize:none;overflow:hidden;outline:none;outline-offset:0;box-shadow:none;background:none;color:", ";padding:", ";", ";text-align:left;margin:", " 0;"],


({ theme }) => theme.colors['Level 1'],









({ theme }) => theme.colors['Level 5'],
({ theme }) => theme.spacers.M,
({ theme }) => theme.typography.Paragraph,

({ theme }) => theme.spacers.M);